<div class="d-flex flex-column justify-content-center gap-1 mat-dialog-container">
  <div class="d-flex justify-content-end" >
    <img class="cursor-pointer" [src]="'assets/svg-icons/close.svg'" alt="" (click)="dialogRef.close()"/>
  </div>
  <div class="d-flex flex-column gap-3 ps-4 pe-4 mb-3">
    <span class="title text-center">{{'shareProposalPDFDialog.title'|translate}}</span>
    <span
      class="body-text">{{'shareProposalPDFDialog.text1'|translate}}</span>
    <span *ngIf="showSizeWarning" style="color: red; font-weight: bold;">{{'shareProposalPDFDialog.sizeWarning'|translate}}</span>
    <label for="emailInput" class="form-label fw-bold small mb-0">{{'shareProposalPDFDialog.emailLabel'|translate}}</label>
    <textarea id="emailInput" class="input input-text-area mb-3" cdkTextareaAutosize
              [cdkAutosizeMinRows]="1"
              [(ngModel)]="email">{{email}}
    </textarea>
    <div class="d-flex flex-row align-items-start gap-2">
      <input type="checkbox" id="gdprConsent" [(ngModel)]="gdprConsentChecked" />
      <label for="gdprConsent" class="small">{{'shareProposalPDFDialog.gdprNotice'|translate}}</label>
    </div>
    <div class="d-flex flex-row w-100 justify-content-between button-container-private">
      <button class="menu-button" (click)="dialogRef.close()">{{'shareProposalPDFDialog.cancel'|translate}}</button>
      <button class="menu-button save-button" [disabled]="!isValidEmail(email) || !gdprConsentChecked" [mat-dialog-close]="true" (click)="shareViaEmail()">{{'shareProposalPDFDialog.share'|translate}}</button>
    </div>
  </div>
</div>

